import { BrowserRouter, HashRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import { AuthProvider } from "@/context/AuthContext";

import Home from "@/pages/Home";
import People from "@/pages/People";
import LawyerDetail from "@/pages/LawyerDetail";
import ExpertiseIndex from "@/pages/ExpertiseIndex";
import ExpertiseDetail from "@/pages/ExpertiseDetail";
import ServiceDetail from "@/pages/ServiceDetail";
import InsightsIndex from "@/pages/InsightsIndex";
import InsightDetail from "@/pages/InsightDetail";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Complaint from "@/pages/Complaint";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminShell from "@/pages/admin/AdminShell";
import AdminDepartments from "@/pages/admin/AdminDepartments";
import AdminServices from "@/pages/admin/AdminServices";
import AdminLawyers from "@/pages/admin/AdminLawyers";
import AdminInsights from "@/pages/admin/AdminInsights";
import AdminContact from "@/pages/admin/AdminContact";
import AuthGate from "@/components/AuthGate";

const STATIC = process.env.REACT_APP_STATIC === "1";
const Guard = ({ children }) => (STATIC ? <AuthGate>{children}</AuthGate> : children);

export default function App() {
  // In static (FTP) builds we use HashRouter so deep links (#/expertise...)
  // work without server rewrite rules — perfect for shared hosting.
  const Router = STATIC ? HashRouter : BrowserRouter;
  return (
    <div className="App">
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/expertise" element={<ExpertiseIndex />} />
            <Route path="/expertise/:slug" element={<ExpertiseDetail />} />
            <Route path="/services/:slug" element={<ServiceDetail />} />
            <Route path="/people" element={<People />} />
            <Route path="/people/:slug" element={<LawyerDetail />} />
            <Route path="/insights" element={<InsightsIndex />} />
            <Route path="/insights/:slug" element={<InsightDetail />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/complaint" element={<Complaint />} />

            <Route path="/admin/login" element={<Guard><AdminLogin /></Guard>} />
            <Route path="/admin" element={<Guard><AdminShell /></Guard>}>
              <Route index element={<Navigate to="/admin/departments" replace />} />
              <Route path="departments" element={<AdminDepartments />} />
              <Route path="services" element={<AdminServices />} />
              <Route path="lawyers" element={<AdminLawyers />} />
              <Route path="insights" element={<AdminInsights />} />
              <Route path="contact" element={<AdminContact />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
        <Toaster richColors position="top-center" />
      </AuthProvider>
    </div>
  );
}
